import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-d-flex p-justify-between" }
const _hoisted_2 = { class: "p-input-icon-right" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)

import { makeTreeTable } from "@/graphql/utils/utils";
import UpdateSector from "./UpdateSector.vue";
import { useRemoveSector } from "./hooks/useRemoveSector";
import { useSectors } from "./hooks/useSectors";
import CreateSector from "./CreateSector.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sectors',
  setup(__props) {

const { loading, sectors, filter } = useSectors();
const { removeLoading, handleRemove } = useRemoveSector();

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TreeTable = _resolveComponent("TreeTable")!

  return (_openBlock(), _createBlock(UpdateSector, null, {
    default: _withCtx(({ openUpdate }) => [
      _createVNode(_component_TreeTable, {
        loading: _unref(loading),
        value: _unref(makeTreeTable)(_unref(sectors), null),
        responsiveLayout: "scroll",
        "filter-mode": "lenient",
        filters: _unref(filter),
        class: "p-treetable-sm"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(CreateSector),
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                placeholder: _ctx.$t('search'),
                modelValue: _unref(filter)['global'],
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter)['global']) = $event))
              }, null, 8, ["placeholder", "modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('category.name'),
            expander: true
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            headerClass: "sm-invisible",
            bodyClass: "sm-invisible",
            field: "createdAt",
            header: "Date de création"
          }, {
            body: _withCtx(({ node }) => [
              _createTextVNode(_toDisplayString(_ctx.$d(node.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "id",
            header: "Action"
          }, {
            body: _withCtx(({ node }) => [
              _createVNode(_component_Button, {
                icon: "pi pi-pencil",
                onClick: ($event: any) => (openUpdate(node.data))
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                icon: "pi pi-trash",
                disabled: _unref(removeLoading),
                onClick: ($event: any) => (_unref(handleRemove)($event, node.key)),
                class: "p-button-danger p-ml-2"
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["loading", "value", "filters"])
    ]),
    _: 1
  }))
}
}

})